import { push } from 'connected-react-router';
import { handleEntryPoint } from './handle-entry-point';
import { parseURI } from '../../helpers/parsers';
import { WeakType } from '../../typescript-migration';
import { handler as setEntryPoint } from '../handlers/setEntryPointHandler';
import { history } from '../../store';

export function navigateTo(
  path: string,
  routerStore: WeakType,
  clearBackStack = false,
): void {
  const normalizedPath = parseURI(path);

  if (clearBackStack) {
    setEntryPoint({ entryPoint: normalizedPath }, routerStore);
    routerStore.dispatch(handleEntryPoint(normalizedPath));
  } else {
    // fix for iOS
    if (!normalizedPath.includes('/search')) {
      history.push({
        pathname: normalizedPath,
      });
    }

    routerStore.dispatch(push(normalizedPath));
  }
}
